// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__1Lrg5","tab":"Tabs_tab__hgw1y","tabActive":"Tabs_tabActive__5lFm_"};